import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import moment from "moment";
import { ToastContainer } from 'react-toastify';
import * as Icon from "react-bootstrap-icons";
// import { FilterReviewModel } from './Model/FilterReviewModel';
import Pagination from '../Common/Pagination';
import { getSelfReview } from './HrSlice';
import { SelfReviewModel } from '../Common/Model/SelfReviewModel';
import useGetEmployees from '../Common/ReuseApi/useGetEmployees';
import useGetDepartments from '../Common/ReuseApi/useGetDepartments';
import useGetSubDepartments from '../Common/ReuseApi/useGetSubDepartments';
import { useProjectList } from '../Common/ReuseApi/useProjectList ';
import SelfReviewFilter from '../Common/Filter/SelfReviewFIlter';
// import { TlReviewModel } from './Model/TlReviewModel';

const HrSelfReview = () => {

  const dispatch = useDispatch()

  const loginUserData = useSelector((state) => state.loginData.userData)
  const selfReviewData = useSelector(state => state?.TLAssignedData?.TlSelfReview)
  const filterAllTasks = useSelector((state) => state?.AllTasks?.AllFilterTasksData);

  // states for filter
  const [project, setProject] = useState(null);
  const [department, setDepartment] = useState(null);
  const [subdepartment, setSubDepartment] = useState(null);
  const [reviewDate, setReviewDate] = useState("");
  const [idcMin, setIdcMin] = useState(null);
  const [idcMax, setIdcMax] = useState(null);
  const [qwdMin, setQwdMin] = useState(null);
  const [qwdMax, setQwdMax] = useState(null);

  const [showperpage, setShowPerPage] = useState(10);
  const [docsPerPage, setDocsPerPage] = useState(10);
  const [showFilter, setShowFilter] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);

  // for show data not found
  const [showNoDataFound, setShowNoDataFound] = useState(false);

  const { employeeOptions } = useGetEmployees();
  const { allDepartmentOptionsById } = useGetDepartments();
  const { subDeptOptions } = useGetSubDepartments(department?.value);
  const { projectOptions, departmentOptions } = useProjectList(project?.value);

  const getReviewData = (page = currentPage) => {
    const empPayload = {
      empId: loginUserData?.empId,
      assignBy_Name: "",
      departments: department?.value ? [department?.value] : [],
      subDepartmentName: subdepartment?.label,
      taskName: "",
      projectName: project?.label ? project?.label : "",
      resource_id: "",
      idc: idcMin?.value || "",
      qwd: qwdMin?.value || "",
      slippage: "",
      efficiency: "",
      reviewDate: reviewDate || "",
      resourceType: "",
      documentsPerPage: docsPerPage,
      page: page
    }
    dispatch(getSelfReview(empPayload))
  }

  useEffect(() => {
    getReviewData()
  }, [currentPage, docsPerPage])

  // for no data found true false
  const handleFilterTrue = () => {
    setShowNoDataFound(true)
  }

  const handleFilterFalse = () => {
    setShowNoDataFound(false)
  }

  const handlerCloseFilterModel = () => setShowFilter(false)

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

  };

  const handleDocsPerPage = (docsPageProp) => {
    setCurrentPage(1)
    setDocsPerPage(docsPageProp);
  }

  const handleSearch = () => {
    setCurrentPage(1)
    getReviewData(1)
  }

  const handleClear = () => {
    setProject(null)
    setDepartment(null)
    setSubDepartment(null)
    setReviewDate("")
    setIdcMin(null)
    setIdcMax(null)
    setQwdMin(null)
    setQwdMax(null)
    setCurrentPage(1)
    dispatch(getSelfReview({
      empId: loginUserData?.empId,
      assignBy_Name: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
      departments: [],
      taskName: "",
      projectName: "",
      resource_id: "",
      idc: "",
      qwd: "",
      slippage: "",
      efficiency: "",
      reviewDate: "",
      resourceType: loginUserData?.resourceType,
      documentsPerPage: docsPerPage,
      page: currentPage
    }))
  }


  return (
    <>
      <div className='outletPadding' data-aos="fade-up">
        <Container>
          <ToastContainer />
          <SelfReviewFilter
            projectOptions={projectOptions}
            departmentOptions={allDepartmentOptionsById}
            subdepartmentOptions={subDeptOptions}
            employeeOptions={employeeOptions}
            idcOptions={[
              { label: "1", value: "1" },
              { label: "2", value: "2" },
              { label: "3", value: "3" },
              { label: "4", value: "4" },
              { label: "5", value: "5" },
              { label: "6", value: "6" },
              { label: "7", value: "7" },
              { label: "8", value: "8" },
              { label: "9", value: "9" },
              { label: "10", value: "10" },
            ]}

            project={project}
            setProject={setProject}
            department={department}
            setDepartment={setDepartment}
            subdepartment={subdepartment}
            setSubDepartment={setSubDepartment}
            reviewDate={reviewDate}
            setReviewDate={setReviewDate}
            idcMin={idcMin}
            setIdcMin={setIdcMin}
            idcMax={idcMax}
            setIdcMax={setIdcMax}
            qwdMin={qwdMin}
            setQwdMin={setQwdMin}
            qwdMax={qwdMax}
            setQwdMax={setQwdMax}

            onSubmit={handleSearch}
            onClear={handleClear}
          />

          <div className='outer-wrapper mx-auto'>
            <div className='table-wrapper'>
              <table>
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th className='assignwidth1'>Project Name</th>
                    <th className='taskwidth'>Task Name</th>
                    <th className='assignwidth1'>Assign By</th>
                    <th>Department</th>
                    <th>IDC</th>
                    <th>QWD</th>
                    <th>Slippage</th>
                    <th>Efficiency</th>
                    <th>Review Date</th>
                  </tr>
                </thead>
                {filterAllTasks?.data?.length > 0 || !showNoDataFound ? (
                  <tbody>
                    {
                      selfReviewData?.data !== null &&
                        selfReviewData?.data !== undefined &&
                        selfReviewData?.data?.length > 0 ? (
                        (filterAllTasks?.data?.length > 0 ? filterAllTasks?.data : selfReviewData?.data).map((itm, index) => {
                          const { taskName, reviewDate, departmentName, taskDepartmentName, projectName,
                            categoryOfName, assignBy_Name, resourceName,
                            idc, qwd, slippage, efficiency } = itm
                          return (
                            <tr key={Math.random() * 999999999}>
                              <td> {currentPage !== 1 ? (
                                <>
                                  {index + 1 + docsPerPage * (currentPage - 1)}
                                </>
                              ) : (
                                <>{index + 1}</>
                              )}</td>
                              <td>{projectName}</td>
                              <td style={{ flexWrap: "wrap" }}>{taskName}</td>
                              <td>{assignBy_Name}</td>
                              <td>{departmentName}</td>
                              <td>{idc !== null && idc !== undefined ? idc.toFixed(2) : 0}</td>
                              <td>{qwd !== null && qwd !== undefined ? qwd.toFixed(2) : 0}</td>
                              <td>{slippage !== undefined && slippage !== null ? slippage.toFixed(2) : 0}</td>
                              <td>{efficiency !== undefined && efficiency !== null ? efficiency.toFixed(2) : 0}</td>
                              <td>{moment(reviewDate).format("DD-MM-YYYY")}</td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr>
                          <td colSpan="18" className="text-center">No data available</td>
                        </tr>
                      )}
                  </tbody>
                )
                  :
                  <tr><td colSpan="16" className="text-center">No Task Available</td></tr>
                }
              </table>
            </div>
          </div>
        </Container>
        {
          selfReviewData?.data !== null || selfReviewData?.data?.length > 0 ?
            <div className="pagination-wrapper p-0">
              <Pagination
                currentPage={currentPage}
                totalPages={filterAllTasks?.data?.length > 0 ? filterAllTasks?.noOfPages : selfReviewData?.noOfPages}
                onPageChange={handlePageChange}
                onDocsPerPage={handleDocsPerPage}
                docsPerPage={docsPerPage}
              />
            </div>
            : ''
        }
      </div>
    </>
  )
}

export default HrSelfReview